<div class="date-selector chart-select">
    <span>{{ statusTitle | i18n }}: </span>
    <div>
        <mat-form-field>
            <mat-select [(value)]="selectedOption" (selectionChange)="optionSelected(selectedOption)">
                <mat-option *ngFor="let option of status" [value]="option.value">{{ option.viewValue | i18n }}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>